export default "__VITE_ASSET__pjlcUVwO__"